/**
 * The autism identification tag (ZOY-666): shown only when the clinic
 * currently identifies the patient as autistic, as a calm attribute of the
 * person — never a warning, never a status dot, and never a "no" counterpart.
 * The wording is the clinic's identification, not a diagnosis.
 */

import { useIntl } from 'react-intl';
import w from './workspace/workspace.module.css';

export function AutismTag({ identified, compact }: { identified: boolean; compact?: boolean }) {
  const intl = useIntl();
  if (!identified) return null;
  return (
    <span className={w.autismTag} data-compact={compact || undefined}>
      <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden fill="none">
        <path
          d="M12 3.5c3.2 3 6.2 6.2 6.2 9.6A6.2 6.2 0 0 1 12 19.3a6.2 6.2 0 0 1-6.2-6.2c0-3.4 3-6.6 6.2-9.6z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
      </svg>
      {intl.formatMessage({ id: 'pt.autismTag' })}
    </span>
  );
}
